export default "__VITE_ASSET__02cc2e25__"